import React from 'react';

// Desktop header details shared by all headers: date + venue, and (when there is
// contact data) the "For Assistance" phone / email, each with an icon tile.
// Styled by the .vh-* rules in public/css/responsive-fixes.css (desktop only).
// The parent header must carry the "visitor-header-light" class.
// Optional: website (link shown under the venue) and note (small line under the
// assistance contacts) - only for headers that have room, i.e. no marquee.
const HeaderInfoTiles = ({ fromDate, toDate, address, mobiles, emails, style, website, note }) => {
    const addr = address || '';
    const comma = addr.indexOf(',');
    const phoneList = Array.isArray(mobiles) ? mobiles.filter(Boolean) : [];
    const emailList = Array.isArray(emails) ? emails.filter(Boolean) : [];
    const column = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' };
    const row = { justifyContent: 'flex-start', width: '100%' };

    return (
        <div className="vh-info d-none d-xl-flex me-auto" style={{ justifyContent: 'flex-start', paddingLeft: 12, ...style }}>
            <div className="vh-block" style={column}>
                <div className="vh-row" style={row}>
                    <span className="vh-icon"><i className="fa fa-calendar"></i></span>
                    <strong className="vh-date">{fromDate} - {toDate}</strong>
                </div>
                {addr && (
                    <div className="vh-row" style={row}>
                        <span className="vh-icon"><i className="fa fa-map-marker"></i></span>
                        <span className="vh-address">
                            {comma > -1 ? <><strong>{addr.slice(0, comma + 1)}</strong>{addr.slice(comma + 1)}</> : addr}
                        </span>
                    </div>
                )}
                {website && (
                    <div className="vh-row" style={row}>
                        <span className="vh-icon"><i className="fa fa-globe"></i></span>
                        <a href={website} target="_blank" rel="noopener noreferrer">{website.replace(/^https?:\/\//, '')}</a>
                    </div>
                )}
            </div>

            {(phoneList.length > 0 || emailList.length > 0) && <>
                <span className="vh-divider"></span>
                <div className="vh-block" style={column}>
                    <div className="vh-row">
                        <span className="vh-icon vh-icon-round"><i className="fa fa-headphones"></i></span>
                        <div>
                            <div className="vh-label">For Assistance</div>
                            <div className="vh-contact">
                                {phoneList.length > 0 && <strong className="vh-phone">{phoneList.join(', ')}</strong>}
                                {emailList.length > 0 && (
                                    <span className="vh-email">
                                        <i className="fa fa-envelope-o"></i>
                                        {emailList.map((data, i) => (
                                            <a key={i} href={`mailto:${data}`}>{data}{i != emailList.length - 1 ? ' / ' : ''}</a>
                                        ))}
                                    </span>
                                )}
                            </div>
                            {note && <div className="vh-label mt-1">{note}</div>}
                        </div>
                    </div>
                </div>
            </>}
        </div>
    );
};

// Reads a JSON array from sessionStorage without throwing on bad / missing data
export const readSessionList = (key) => {
    try {
        const value = JSON.parse(sessionStorage.getItem(key));
        return Array.isArray(value) ? value : [];
    } catch (e) {
        return [];
    }
};

export default HeaderInfoTiles;
